import { styled } from '@mui/material';

export const SOptionRow = styled('button', {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected: boolean }>(({ isSelected, theme }) => ({
  alignItems: 'center',
  background: isSelected ? theme.palette.primary[50] : theme.palette.common.white,
  border: `1px solid ${isSelected ? theme.palette.primary[500] : theme.palette.grey[300]}`,
  borderRadius: 8,
  boxSizing: 'border-box',
  cursor: 'pointer',
  display: 'flex',
  height: 40,
  justifyContent: 'space-between',
  padding: '9px 15px',
  textAlign: 'left',
  width: '100%',
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary[500]}`,
    outlineOffset: 2,
  },
}));

export const SCheckCircle = styled('span', {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected: boolean }>(({ isSelected, theme }) => ({
  alignItems: 'center',
  background: isSelected ? theme.palette.primary[600] : theme.palette.common.white,
  border: `1px solid ${isSelected ? theme.palette.primary[600] : theme.palette.grey[300]}`,
  borderRadius: 8,
  display: 'flex',
  flexShrink: 0,
  height: 16,
  justifyContent: 'center',
  width: 16,
  '& svg': {
    color: theme.palette.common.white,
    height: 10,
    width: 10,
  },
  '& svg *': {
    fill: theme.palette.common.white,
    stroke: theme.palette.common.white,
  },
}));
